<template lang="pug">
  svg.svg-clock(:x="x" :y="y" :width="width" :height="width" viewBox="0 0 74 74" preserveAspectRatio="xMidYMid meet")
    title Clock
    g#clock-face
      circle(cx="37" cy="37" r="37")
      circle.clock-cls-1(cx="37" cy="37" r="34.23")
      line.clock-cls-2(x1="4.63" y1="37" x2="10.18" y2="37")
      line.clock-cls-2(x1="8.96" y1="53.19" x2="13.77" y2="50.41")
      line.clock-cls-2(x1="20.81" y1="65.04" x2="23.59" y2="60.23")
      line.clock-cls-2(x1="37" y1="69.38" x2="37" y2="63.83")
      line.clock-cls-2(x1="53.19" y1="65.04" x2="50.41" y2="60.23")
      line.clock-cls-2(x1="65.04" y1="53.19" x2="60.23" y2="50.41")
      line.clock-cls-2(x1="69.38" y1="37" x2="63.83" y2="37")
      line.clock-cls-2(x1="65.04" y1="20.81" x2="60.23" y2="23.59")
      line.clock-cls-2(x1="53.19" y1="8.96" x2="50.41" y2="13.77")
      line.clock-cls-2(x1="37" y1="4.63" x2="37" y2="10.17")
      line.clock-cls-2(x1="20.81" y1="8.96" x2="23.59" y2="13.77")
      line.clock-cls-2(x1="8.96" y1="20.81" x2="13.77" y2="23.59")
      circle(cx="37" cy="37" r="2")
    rect#hour-hand(x="36" y="23" width="2" height="15" :style="{ transform: hourRotation }")
    rect#minute-hand(x="36" y="13" width="2" height="25" :style="{ transform: minuteRotation }")
    rect#second-hand(x="36.5" y="8" width="1" height="30" :style="{ transform: secondRotation }")
</template>

<script>
export default {
  name: 'svg-oven',

  props: {
    x: Number,
    y: Number,
    width: {
      type: Number,
      default: 74,
    },
  },

  data() {
    return {
      hour: 0,
      minute: 0,
      second: 0,
    };
  },

  computed: {
    hourRotation() {
      const degrees = ((this.hour % 12) + (this.minute / 60)) * 30;
      return `rotate(${degrees}deg`;
    },

    minuteRotation() {
      const degrees = (this.minute + (this.second / 60)) * 6;
      return `rotate(${degrees}deg`;
    },

    secondRotation() {
      const degrees = this.second * 6;
      return `rotate(${degrees}deg`;
    },
  },

  mounted() {
    this.updateTime();
  },

  methods: {
    updateTime() {
      const now = new Date();
      this.hour = now.getHours();
      this.minute = now.getMinutes();
      this.second = now.getSeconds();
      setTimeout(() => this.updateTime(), 1000);
    },
  },

};
</script>

<style lang="scss" scoped>
.svg-clock {

  #hour-hand,#minute-hand,#second-hand {
    transform-origin: 37px 37px;
  }

  #second-hand {
    fill: #a43d2d;
  }

  .clock-cls-1 {
    fill: var(--fill-color-1, #fff);
    stroke: var(--stroke-color-1, none);
    stroke-width: var(--stroke-width-1, 1px);
    stroke-miterlimit: 4;
    vector-effect: non-scaling-stroke;
  }
  .clock-cls-2 {
    fill: var(--fill-color-2, none);
    stroke: var(--stroke-color-2, #000);
    stroke-width: var(--stroke-width-2, 2px);
    stroke-miterlimit: 10;
    vector-effect: non-scaling-stroke;
  }
}
</style>
